import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { DealTypeContainer } from '../../containers/filters/DealTypeContainer';

export const dealType: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: DealTypeContainer,
};
